var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1212C0 13.5905 2.05147 11.5391 4.58209 11.5391C7.11271 11.5391 9.16419 13.5905 9.16419 16.1212V19.8954C9.16419 20.3569 8.79006 20.7311 8.32855 20.7311H0.835636C0.374127 20.7311 0 20.3569 0 19.8954V16.1212Z",
    fill: "#9C9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3359 16.4511C20.3359 18.9817 18.2845 21.0332 15.7538 21.0332C13.2232 21.0332 11.1717 18.9817 11.1717 16.4511L11.1717 12.8685C11.1717 12.4176 11.5373 12.0521 11.9882 12.0521L19.5195 12.0521C19.9704 12.0521 20.3359 12.4176 20.3359 12.8685L20.3359 16.4511Z",
    fill: "#9C9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.08777C0 0.890437 0.159969 0.730469 0.3573 0.730469H7.19206C7.51012 0.730469 7.66965 1.1148 7.44509 1.34004L0.610328 8.19535C0.385397 8.42096 0 8.26166 0 7.94308L0 1.08777Z",
    fill: "#9C9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 9.56458C9.16406 9.76191 9.00409 9.92187 8.80676 9.92187L1.972 9.92187C1.65394 9.92187 1.49441 9.53755 1.71898 9.3123L8.55374 2.457C8.77867 2.23139 9.16406 2.39069 9.16406 2.70927L9.16406 9.56458Z",
    fill: "#9C9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3359 5.33978C20.3359 7.8704 18.2845 9.92187 15.7538 9.92187C13.2232 9.92187 11.1717 7.8704 11.1717 5.33978L11.1717 1.56575C11.1717 1.10425 11.5459 0.730132 12.0074 0.730132L19.5003 0.730133C19.9618 0.730133 20.3359 1.10425 20.3359 1.56575L20.3359 5.33978Z",
    fill: "#9C9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuIconInactive);
export default __webpack_public_path__ + "static/media/zunu_icon_inactive.14f3ccecde599a42adbd08be1dc6b283.svg";
export { ForwardRef as ReactComponent };